import { Validation, ValueObject } from '@singularsystems/neo-core';
import { Display } from '@singularsystems/neo-core/dist/Model/Decorators';
import { FieldSetting } from './FieldSetting';
import { MandatoryAndVisibleSetting, MandatorySetting, VisibleSetting } from './FieldSetting.enum';

export default class IssuerFieldConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public registrationNumber: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("CIS Numbers")
    public cisNumbers: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public taxRefNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public postalAddress: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public physicalAddress: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Internal Rating")
    public internalRatingId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Intra Group")
    public intraGroupId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Sector")
    public sectorId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Authorised Person Contact")
    @FieldSetting(MandatorySetting)
    public authorisedPersonContactId: MandatorySetting = MandatorySetting.NotMandatory;

    @Display("Contacts")
    @FieldSetting(MandatorySetting)
    public contacts: MandatorySetting = MandatorySetting.NotMandatory;

    @Display("Asset Class")
    public assetClassId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Country")
    public countryId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public withholdingAgentReferenceNumber: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public ledgerAccount: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public ficaDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Sanctioned Screening Performed")
    @FieldSetting(VisibleSetting)
    public sactionedScreeningPerformed: VisibleSetting = VisibleSetting.Visible;

    @Display("Restricted From Trading")
    @FieldSetting(VisibleSetting)
    public isRestricted: VisibleSetting = VisibleSetting.Visible;

    
    @Display("SARS Nature Of Person")
    public sarsNatureOfPersonId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public lossGivenDefault: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Issuer Fields Config";
    }
}